import * as React from "react";

import { SearchPanelProps, SearchForm } from '../Search/Search';
import { Button } from '../../../../components/Buttons';
import { EntityType } from "../../../../models/EntityType";
import { SearchTextField } from "../Search/SearchTextField";
import { Spinner } from "../../../../components/Spinner/index";
import { ErrorMessage } from "../../../../components/ErrorMessage/index";
import { Polyglot } from "../../../../polyglot";

const styles = require('../Search/EntitySearch.scss');
const helperStyles = require('../../../../components/BootstrapHelper.local.css');

interface SearchRequest
{
    UserInput: string;
}
interface FormProps
{
    polyglot: Polyglot;
}
type Props = SearchPanelProps<SearchRequest> & FormProps;

export class GenericSearch extends SearchForm<Props, {}>
{
    private refUserInput: SearchTextField;
    
    render ()
    {
        const { searchParams, searchInProgress, errorMessage } = this.props;
        const { UserInput = '' } = searchParams;
        
        return (
            <form className='form-inline' onSubmit={this.onSubmit.bind(this)} onChange={this.onChange.bind(this)}>
                <SearchTextField title={`${this.props.polyglot.t('search.title')}:`} value={UserInput} ref={e => this.refUserInput=e} className={styles.UserInput}/>
                <Button disabled={searchInProgress} leftIcon="search">{this.props.polyglot.t('button.find')}</Button>
                { searchInProgress && <Spinner className={helperStyles.MarginLeft} /> }
                <ErrorMessage errorMessage={errorMessage} className={helperStyles.MarginLeft}/>
            </form>
        );
    }

    getValue(): SearchRequest
    {
        return {
            UserInput: this.refUserInput.getValue(),
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Search/GenericSearch.tsx